<!--suppress CssUnresolvedCustomProperty -->
<template>
  <v-container fluid class="pa-6"
               style="max-width: 83%;"
  >

    <v-row>
      <v-col cols="12">

        <!-- TITLE -->
        <div class="mb-6">
          <h1 class="text-h4 font-weight-black">
            {{ $route.params.processName }}
          </h1>
        </div>

        <!-- CONTENT -->
        <div v-if="processesStore.processRequirements">

          <v-card
              v-if="descripcion"
              class="pa-6 mb-6"
              rounded="xl"
              elevation="2"
          >
            <div v-html="descripcion.content"></div>

            <div class="cards-grid mt-6">
              <v-card
                  v-for="item in otros"
                  :key="item.id"
                  class="pa-6"
                  rounded="xl"
                  elevation="1"
              >
                <div v-html="item.content"></div>
              </v-card>
            </div>

          </v-card>

        </div>

        <!-- ACTIONS -->
        <v-row class="mt-8">
          <v-col
              cols="12"
              class="d-flex justify-end flex-wrap"
              style="gap: 20px;"
          >
            <v-btn
                to="/processes"
                x-large
                outlined
                rounded="lg"
                class="font-weight-medium"
            >
              <v-icon left>mdi-arrow-left</v-icon>
              Regresar
            </v-btn>

            <v-btn
                :to="{name: 'procedure_create', params: {processId: $route.params.processId}}"
                x-large
                class="main_color white--text"
                rounded="lg"
            >
              Iniciar Trámite
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

  </v-container>
</template>
<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import {processRequirementsRequest} from "../api/models";

export default {
    name: "ProcessRequirements",
    components: {
    },
  computed: {
    ...mapState({
      account: state => state.account,
      processesStore: state => state.processes
    }),

    descripcion() {
      if (!this.processesStore.processRequirements) return null

      return this.processesStore.processRequirements.find(c =>
          c.title.trim().toLowerCase() === 'descripcion'
      )
    },

    otros() {
      if (!this.processesStore.processRequirements) return []

      return this.processesStore.processRequirements.filter(c =>
          c.title.trim().toLowerCase() !== 'descripcion'
      )
    }
  },
    created() {
        window.addEventListener("resize", this.resizeWindow);
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeWindow);
    },
    data() {
        return {
            tab: null,
            tabInitProceso: 'requisitos',
            window: 0,
            totalWindows: 4,
            windowWidth: window.innerWidth
        }
    },

    watch: {
        '$store.state.account.user'(){
            if (this.account.loggedIn){
                this.getRequirements()
            }
        },

        '$store.state.processes.processRequirements'(prerequirements){
            if (prerequirements && this.isGuestUser){
                this.verifyGuestUser()
            }
        }
    },

    mounted() {
        this.checkAuthentication()
    },

    methods: {
        ...mapActions('processes', ['getProcessRequirements']),
        ...mapActions('account', ['login', 'logout']),
        ...mapActions('alerts', ['error']),
        ...mapGetters('account', ['isGuestUser']),

        resizeWindow(e){
            this.windowWidth = e.target.innerWidth
        },


        getRequirements(){
            let request = processRequirementsRequest()
            request.processId = this.$route.params.processId
            request.userId = this.account.user.id

            //Call from VueX
            this.getProcessRequirements(request)
        },

        checkAuthentication(){
            if (this.account.loggedIn){
                this.getRequirements();
            }else{
                let isInvited = this.$router.currentRoute.query.invited == 1

                if (isInvited){
                    this.requestLoginAsInvited()
                }else {
                    this.$router.push({name: 'login'})
                }
            }
        },

        requestLoginAsInvited(){
            let request = {username: process.env.VUE_APP_INVITED_USERNAME, password:  process.env.VUE_APP_INVITED_PASSWORD}
            this.login(request)

        },

        verifyGuestUser(){
            if (!this.processesStore.processRequirementsShow){
                this.error(this.processesStore.processRequirements[0].content)
                this.logout()
            }
        },

    },
}
</script>

<style scoped>

    .container-require{
      margin: 1.5rem;

    }

    .actions-container{
      display: flex;
      justify-content: flex-end;
      gap: 20px;
      margin-top: 30px;
    }

    .back-button{
      border-radius: 12px;
      font-weight: 600;
    }

    .start-button{
      background-color: #6d0f2b !important; /* puedes usar tu main_color */
      color: white !important;
      border-radius: 12px;
      font-weight: 600;
    }


    .main-card {
      border-radius: 20px;
    }

    .cards-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
      gap: 24px;
    }

    .secondary-card {
      border-radius: 20px;
      border: 1px solid ;
      background: rgba(18, 49, 43, 0.05);
    }
</style>